import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CartItem, CartItemType } from '../components/CartItem';
import { Button } from '../components/ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, ArrowRight, ShieldCheck, CreditCard, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Cart() {
  // Mock initial cart state
  const [cartItems, setCartItems] = useState<CartItemType[]>([{
    id: '1',
    type: 'table',
    title: 'Diamond VIP Table',
    subtitle: 'Main Floor • Center Stage View',
    date: 'Oct 28, 2023',
    time: '10:00 PM',
    location: 'Section A, Table 12',
    guests: 8,
    price: 2500,
    deposit: 500,
    image: 'https://images.unsplash.com/photo-1570752321219-41822a21a761?w=800&h=600&fit=crop'
  }, {
    id: '2',
    type: 'room',
    title: 'Platinum VIP Suite',
    subtitle: 'Private Penthouse Access',
    date: 'Oct 28, 2023',
    time: 'Check-in: 9:00 PM',
    guests: 15,
    price: 5000,
    deposit: 1000,
    image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&h=600&fit=crop'
  }]);
  const handleRemoveItem = (id: string) => {
    setCartItems(prev => prev.filter(item => item.id !== id));
  };
  const subtotal = cartItems.reduce((acc, item) => acc + item.price, 0);
  const depositTotal = cartItems.reduce((acc, item) => acc + (item.deposit || 0), 0);
  const tax = subtotal * 0.08;
  const serviceCharge = subtotal * 0.2; // 20% gratuity standard for nightlife
  const total = subtotal + tax + serviceCharge;
  return <div className="min-h-screen bg-[#0B1014] text-white flex flex-col" data-id="element-798">
      <Header data-id="element-799" />

      {/* Hero Header */}
      <div className="relative pt-32 pb-12 overflow-hidden" data-id="element-800">
        <div className="absolute inset-0 bg-gradient-to-b from-[#DDA247]/5 via-transparent to-transparent" data-id="element-801" />
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#DDA247]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-802" />

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-803">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-804">
            <div className="flex items-center gap-3 mb-4" data-id="element-805">
              <ShoppingBag className="w-5 h-5 text-[#DDA247]" data-id="element-806" />
              <span className="text-sm text-[#DDA247] uppercase tracking-[0.2em] font-medium" data-id="element-807">
                Your Selection
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white uppercase tracking-tight mb-4" data-id="element-808">
              Booking Summary
            </h1>
          </motion.div>
        </div>
      </div>

      <main className="flex-1 container mx-auto px-4 md:px-6 pb-20" data-id="element-809">
        {cartItems.length > 0 ? <div className="flex flex-col lg:flex-row gap-12" data-id="element-810">
            {/* Cart Items List */}
            <div className="flex-1 space-y-6" data-id="element-811">
              <AnimatePresence mode="popLayout" data-id="element-812">
                {cartItems.map(item => <CartItem key={item.id} item={item} onRemove={handleRemoveItem} data-id="element-813" />)}
              </AnimatePresence>

              {/* Upsell / Recommendations */}
              <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.4
          }} className="mt-12 pt-12 border-t border-white/10" data-id="element-814">
                <h3 className="text-lg font-bold uppercase tracking-wide mb-6 flex items-center gap-2" data-id="element-815">
                  <Sparkles className="w-4 h-4 text-[#DDA247]" data-id="element-816" />
                  Complete Your Experience
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-817">
                  <Link to="/bottle-service" className="group block bg-[#1A2228] p-4 rounded-lg border border-white/5 hover:border-[#DDA247]/30 transition-all" data-id="element-818">
                    <div className="flex items-center gap-4" data-id="element-819">
                      <div className="w-16 h-16 bg-gray-800 rounded overflow-hidden" data-id="element-820">
                        <img src="https://images.unsplash.com/photo-1597075687490-8f673c6c17f6?w=200&h=200&fit=crop" alt="Champagne" className="w-full h-full object-cover" data-id="element-821" />
                      </div>
                      <div data-id="element-822">
                        <h4 className="font-bold text-white group-hover:text-[#DDA247] transition-colors" data-id="element-823">
                          Add Champagne
                        </h4>
                        <p className="text-xs text-gray-400 mt-1" data-id="element-824">
                          Pre-order & save 10%
                        </p>
                      </div>
                      <div className="ml-auto" data-id="element-825">
                        <div className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center group-hover:bg-[#DDA247] group-hover:text-black transition-colors" data-id="element-826">
                          <ArrowRight className="w-4 h-4" data-id="element-827" />
                        </div>
                      </div>
                    </div>
                  </Link>
                  <Link to="/vip-hosts" className="group block bg-[#1A2228] p-4 rounded-lg border border-white/5 hover:border-[#DDA247]/30 transition-all" data-id="element-828">
                    <div className="flex items-center gap-4" data-id="element-829">
                      <div className="w-16 h-16 bg-gray-800 rounded overflow-hidden" data-id="element-830">
                        <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop" alt="Host" className="w-full h-full object-cover" data-id="element-831" />
                      </div>
                      <div data-id="element-832">
                        <h4 className="font-bold text-white group-hover:text-[#DDA247] transition-colors" data-id="element-833">
                          Dedicated Host
                        </h4>
                        <p className="text-xs text-gray-400 mt-1" data-id="element-834">
                          Personal concierge service
                        </p>
                      </div>
                      <div className="ml-auto" data-id="element-835">
                        <div className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center group-hover:bg-[#DDA247] group-hover:text-black transition-colors" data-id="element-836">
                          <ArrowRight className="w-4 h-4" data-id="element-837" />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </motion.div>
            </div>

            {/* Order Summary */}
            <div className="lg:w-[400px] flex-shrink-0" data-id="element-838">
              <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2
          }} className="bg-[#1A2228] border border-white/10 rounded-2xl p-6 sticky top-24" data-id="element-839">
                <h2 className="text-xl font-bold uppercase tracking-wide mb-6 pb-4 border-b border-white/10" data-id="element-840">
                  Order Summary
                </h2>

                <div className="space-y-4 mb-6" data-id="element-841">
                  <div className="flex justify-between text-gray-400" data-id="element-842">
                    <span data-id="element-843">Subtotal</span>
                    <span className="text-white font-medium" data-id="element-844">
                      ${subtotal.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex justify-between text-gray-400" data-id="element-845">
                    <span data-id="element-846">Service Charge (20%)</span>
                    <span className="text-white font-medium" data-id="element-847">
                      ${serviceCharge.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex justify-between text-gray-400" data-id="element-848">
                    <span data-id="element-849">Taxes</span>
                    <span className="text-white font-medium" data-id="element-850">
                      ${tax.toLocaleString()}
                    </span>
                  </div>
                </div>

                <div className="flex justify-between items-end py-4 border-t border-white/10 mb-6" data-id="element-851">
                  <div data-id="element-852">
                    <span className="text-sm text-gray-400 uppercase tracking-wider block mb-1" data-id="element-853">
                      Total
                    </span>
                    <span className="text-xs text-[#DDA247]" data-id="element-854">
                      Due Today: ${depositTotal.toLocaleString()}
                    </span>
                  </div>
                  <span className="text-3xl font-bold text-white" data-id="element-855">
                    ${total.toLocaleString()}
                  </span>
                </div>

                <Link to="/book-now" data-id="element-856">
                  <Button fullWidth size="lg" className="mb-4" data-id="element-857">
                    PROCEED TO CHECKOUT
                  </Button>
                </Link>

                <div className="flex items-center justify-center gap-2 text-xs text-gray-500 mb-6" data-id="element-858">
                  <ShieldCheck className="w-3 h-3" data-id="element-859" />
                  <span data-id="element-860">Secure SSL Encrypted Payment</span>
                </div>

                <div className="bg-white/5 rounded-lg p-4" data-id="element-861">
                  <h4 className="text-sm font-bold text-white mb-2 flex items-center gap-2" data-id="element-862">
                    <CreditCard className="w-4 h-4 text-[#DDA247]" data-id="element-863" />
                    Payment Policy
                  </h4>
                  <p className="text-xs text-gray-400 leading-relaxed" data-id="element-864">
                    A deposit of ${depositTotal.toLocaleString()} is required to
                    secure your reservation. The remaining balance will be due
                    upon arrival at the venue.
                  </p>
                </div>
              </motion.div>
            </div>
          </div> /* Empty State */ : <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="flex flex-col items-center justify-center py-20 text-center" data-id="element-865">
            <div className="w-24 h-24 bg-[#1A2228] rounded-full flex items-center justify-center mb-6" data-id="element-866">
              <ShoppingBag className="w-10 h-10 text-gray-600" data-id="element-867" />
            </div>
            <h2 className="text-2xl font-bold text-white uppercase tracking-wide mb-2" data-id="element-868">
              Your Cart is Empty
            </h2>
            <p className="text-gray-400 max-w-md mb-8" data-id="element-869">
              Looks like you haven't added any experiences yet. Browse our
              exclusive tables and rooms to get started.
            </p>
            <div className="flex gap-4" data-id="element-870">
              <Link to="/bottle-service" data-id="element-871">
                <Button variant="outline" data-id="element-872">Browse Tables</Button>
              </Link>
              <Link to="/book-room" data-id="element-873">
                <Button data-id="element-874">View Rooms</Button>
              </Link>
            </div>
          </motion.div>}
      </main>

      <Footer data-id="element-875" />
    </div>;
}